export const statuses = {
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  PAID: 'PAID',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
  PAID_OUT: 'PAID_OUT',
};
